import { Box } from "@mantine/core"
import { ArrowRightIcon } from "@phosphor-icons/react"
import { HelpMarkup, helpText } from "@dehub/theme"

/**
 * ConfirmNote for content rendered outside the HelpProvider tree (`modals.openConfirmModal` mounts in the
 * ModalsProvider above HelpRoot): reads the `confirm` row through `helpText()` instead of the React context.
 * Renders nothing without content (R10).
 */
export function HelpNote({ helpKey, mt = 12 }: Readonly<{ helpKey: string; mt?: number }>) {
  const text = helpText(helpKey)
  if (!text) return null
  return (
    <Box
      style={{
        display: "flex", gap: 8, alignItems: "flex-start", marginTop: mt, padding: "10px 14px", borderRadius: 10,
        background: "#f8fafc", border: "1px solid #e2e8f0", fontSize: 14, lineHeight: 1.5, color: "#334155", textAlign: "left",
      }}>
      <ArrowRightIcon size={16} weight="bold" style={{ marginTop: 3, flexShrink: 0, color: "#64748b" }} aria-hidden="true" />
      <span>
        <HelpMarkup text={text} />
      </span>
    </Box>
  )
}
